import * as React from 'react'
import { Link } from '@ally/metronome-ui'
import { AdobeTile } from '../types'

interface ComponentProps {
  tileData: AdobeTile
}

const CtaLink: React.FC<ComponentProps> = ({ tileData }) => {
  return (
    <Link
      to={tileData.ctaHref}
      text={tileData.ctaLabel}
      aria-label={tileData.ariaText}
    />
  )
}

export default CtaLink
